import React, { useEffect } from 'react';
import Footer from '../components/Footer'

import gal1 from '../images/gal (1).png';
import gal2 from '../images/gal (2).png';
import gal3 from '../images/gal (3).png';
import gal4 from '../images/gal (4).png';
import gal5 from '../images/gal (5).png';
import gal6 from '../images/gal (6).png';
import gal7 from '../images/gal (7).png';
import gal8 from '../images/gal (8).png';
import gal9 from '../images/gal (9).png';
import gal10 from '../images/gal (10).png';

const Gallery = () => {

      useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
    const images = [gal1, gal2, gal3, gal4, gal5, gal6 , gal7 , gal8, gal9,gal10];
    return (
        <div>


            <div className="container my-4">
                <div className="d-flex justify-content-center">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb bg-light p-2 rounded">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Gallery</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container py-5">

                <div className="row g-4">
                    {images.map((img, index) => (
                        <div className="col-sm-6 col-md-4" key={index}>
                            <div className="card h-100 shadow-sm border-0">
                                <img
                                    src={img}
                                    alt={`homeopathy-${index + 1}`}
                                    className="card-img-top rounded"
                                    style={{ objectFit: 'cover', height: '250px' }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Gallery